import { PartPricesResponse } from 'hooks/useGetPrices';
import { DELIVERY_TAXES_KEYS, TAXES_DATA_KEYS, TOTAL_TAXES_DATA_KEYS } from 'model/taxes';
import { OrderType } from 'types/OrderType';
import { PartPrices } from 'types/UFOTypes';

export type TaxesType = { name: string; amount: number }[];

export const getTAXES = (prices: PartPrices, quantity?: number) =>
  TAXES_DATA_KEYS.filter((tax) => prices[tax.key] && Number.parseFloat((prices[tax.key] as string) ?? '0') > 0).map(
    (tax) => {
      const qty = Number.parseInt(prices.qty ?? '', 10);
      return {
        name: tax.translation,
        amount:
          qty && quantity
            ? (Number.parseFloat(prices[tax.key] as string) / qty) * quantity
            : Number.parseFloat(prices[tax.key] as string),
      };
    },
  );

export const getDeliveryTaxes = (prices?: PartPricesResponse | OrderType | null) => {
  if (!prices) return [];
  return DELIVERY_TAXES_KEYS.filter(
    (tax) => prices[tax.key] && Number.parseFloat((prices[tax.key] as string) ?? '0') > 0,
  ).map((tax) => ({
    name: tax.translation,
    amount: Number.parseFloat(prices[tax.key] as string),
  }));
};

export const getTotalDeliveryTaxes = (prices?: PartPricesResponse | OrderType | null) => {
  if (!prices) return 0;
  return DELIVERY_TAXES_KEYS.filter((tax) => prices[tax.key]).reduce(
    (s, { key }) => s + Number(Number.parseFloat((prices[key] as string) ?? '0') || 0),
    0,
  );
};

export const getTotalPartTAX = (prices: PartPrices, quantity?: number) => {
  const qty = Number.parseInt(prices.qty ?? '', 10);
  if (quantity && qty)
    return (
      (TAXES_DATA_KEYS.reduce((s, { key }) => s + Number(Number.parseFloat((prices[key] as string) ?? '0') || 0), 0) /
        qty) *
      quantity
    );
  return TAXES_DATA_KEYS.reduce((s, { key }) => s + Number(Number.parseFloat((prices[key] as string) ?? '0') || 0), 0);
};

export const getOrderTAXES = (order: OrderType) =>
  TOTAL_TAXES_DATA_KEYS.filter((tax) => order[tax.key] && Number.parseFloat(order[tax.key] ?? '0') > 0).map((tax) => ({
    name: tax.translation,
    amount: Number.parseFloat(order[tax.key]),
  }));

export const getTotalOrderTAX = (order: OrderType) =>
  TOTAL_TAXES_DATA_KEYS.reduce((s, { key }) => s + Number(Number.parseFloat(order[key] ?? '0') || 0), 0) +
  getTotalDeliveryTaxes(order);
